import { required } from "@/filters";

export default {
  computed: {
    isRequired() {
      return typeof this.rules == "string" && this.rules.includes("required");
    },
  },

  created() {
    this.$attrs.label = required(this.$attrs.label, this.isRequired);
  },
  beforeUpdate() {
    this.$attrs.label = required(this.$attrs.label, this.isRequired);
  },
};
